<script >
export default {
  props: {
    callBack: {
      type: Function,
      required: true
    },
  }
};
</script>

<template>
  <b-button
    class="btn btn-secondary px-5 py-3 fw-semibold font-weight-bold z-2 secondary-button"
    @click="callBack"
  >
    <slot></slot>
  </b-button>
</template>

<style scoped>
.secondary-button {
  border-radius: 12px;
}
</style>